/* assets/wishlist.js — core, with theme-styled toast */
(function () {
  const LS_KEY = "wishlist";
  const doc = document;
  const $ = (sel, root = doc) => root.querySelector(sel);
  const $$ = (sel, root = doc) => Array.from(root.querySelectorAll(sel));

  // ---------- utils ----------
  function normalizeHandle(raw) {
    if (!raw) return "";
    let s = String(raw).trim();
    if (!s) return "";
    if (s.includes("/")) {
      try {
        const u = new URL(s, location.origin);
        const m = u.pathname.match(/\/products\/([^/]+)/);
        if (m && m[1]) s = decodeURIComponent(m[1]);
      } catch {
        const p = s.split("?")[0].split("/products/");
        if (p.length > 1) s = decodeURIComponent(p[1].split("/")[0]);
      }
    }
    return s.toLowerCase();
  }

  function readLS() {
    try {
      const arr = JSON.parse(localStorage.getItem(LS_KEY)) || [];
      return Array.from(new Set(arr.map(normalizeHandle))).filter(Boolean);
    } catch {
      return [];
    }
  }
  function writeLS(list) {
    localStorage.setItem(LS_KEY, JSON.stringify(list));
  }

  // ---------- core API ----------
  const API = {
    getEntries() {
      return readLS().map((h) => ({ handle: h }));
    },
    has(handle) {
      handle = normalizeHandle(handle);
      return readLS().includes(handle);
    },
    add(handle) {
      handle = normalizeHandle(handle);
      if (!handle) return this.getEntries();
      const list = readLS();
      if (!list.includes(handle)) {
        list.push(handle);
        writeLS(list);
        broadcast(list);
      }
      return list.map((h) => ({ handle: h }));
    },
    remove(handle) {
      handle = normalizeHandle(handle);
      if (!handle) return this.getEntries();
      const list = readLS().filter((h) => h !== handle);
      writeLS(list);
      broadcast(list);
      return list.map((h) => ({ handle: h }));
    },
    toggle(handle) {
      return this.has(handle) ? this.remove(handle) : this.add(handle);
    },
    count() {
      return readLS().length;
    },
  };

  // expose global
  window.CharmetixWishlist = window.CharmetixWishlist || API;

  // ---------- UI: header count ----------
  function padCount(n) {
    if (n > 99) return "99+";
    return String(n);
  }
  function updateHeaderCount() {
    const n = API.count();
    $$("[data-wishlist-count]").forEach((el) => {
      el.textContent = n ? padCount(n) : "";
      el.style.display = n ? "grid" : "none";
    });
  }

  // ---------- UI: toast (theme-styled) ----------
  function getGlobalToast() {
    let t = $("#wl-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "wl-toast";
      t.className = "wl-toast";
      t.setAttribute("role", "status");
      t.setAttribute("aria-live", "polite");
      t.setAttribute("aria-atomic", "true");
      document.body.appendChild(t);
    }
    return t;
  }

  function toast(message, scope) {
    // Prefer slot lokal jika ada
    const local = scope?.querySelector?.("[data-wishlist-toast]") || null;
    if (local) {
      local.textContent = message;
      local.classList.add("is-visible");
      clearTimeout(local.__t);
      local.__t = setTimeout(() => {
        local.classList.remove("is-visible");
        local.textContent = "";
      }, 2000);
    }

    // Fallback: bubble global (kanan-atas)
    const wrap = getGlobalToast();
    const n = document.createElement("div");
    n.className = "wl-toast__item";
    n.textContent = message;
    wrap.appendChild(n);
    // animate in
    requestAnimationFrame(() => n.classList.add("wl-toast__item--show"));
    // auto close
    setTimeout(() => {
      n.classList.remove("wl-toast__item--show");
      setTimeout(() => n.remove(), 180);
    }, 1400);
  }

  // ---------- events ----------
  function broadcast(list) {
    updateHeaderCount();
    const detail = {
      entries: list.map((h) => ({ handle: h })),
      count: list.length,
    };
    document.dispatchEvent(new CustomEvent("wishlist:updated", { detail }));
  }

  // ---------- binding: buttons ----------
  function labelSwap(btn, added) {
    const addLabel =
      btn.getAttribute("data-wishlist-label-add") || "Add to wishlist";
    const rmLabel =
      btn.getAttribute("data-wishlist-label-remove") || "Remove from wishlist";
    btn.setAttribute("aria-pressed", added ? "true" : "false");
    btn.setAttribute("aria-label", added ? rmLabel : addLabel);
    btn.classList.toggle("active", !!added);
  }

  function bindButtons(root = doc) {
    // New API buttons
    $$("[data-wishlist-button]", root).forEach((btn) => {
      if (btn.__wlBound) return;
      btn.__wlBound = true;

      const handle = normalizeHandle(
        btn.getAttribute("data-handle") ||
          btn.getAttribute("data-product-handle") ||
          btn.getAttribute("data-product-url") ||
          ""
      );

      // initial
      labelSwap(btn, API.has(handle));

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const added = !API.has(handle);
        API.toggle(handle);
        labelSwap(btn, added);

        const msg = added
          ? btn.getAttribute("data-wishlist-toast-add") || "Added to wishlist"
          : btn.getAttribute("data-wishlist-toast-remove") ||
            "Removed from wishlist";

        const scope =
          btn.closest("[data-wishlist-toast-container]") || btn.parentElement;
        toast(msg, scope);
      });
    });

    // Legacy `.wt-button`
    $$(".wt-button", root).forEach((btn) => {
      if (btn.__wlBound) return;
      btn.__wlBound = true;

      const handle = normalizeHandle(
        btn.getAttribute("data-product-handle") || ""
      );
      const on = API.has(handle);
      btn.classList.toggle("active", on);

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const added = !API.has(handle);
        API.toggle(handle);
        btn.classList.toggle("active", added);
        toast(added ? "Added to Wishlist." : "Removed from Wishlist.", btn);
      });
    });
  }

  // ---------- boot ----------
  function init() {
    updateHeaderCount();
    bindButtons(doc);
    // initial broadcast to sync pages listening
    broadcast(readLS());
  }

  document.addEventListener("DOMContentLoaded", init);

  // rebind when sections load in editor etc.
  document.addEventListener("shopify:section:load", (e) =>
    bindButtons(e.target)
  );
  document.addEventListener("shopify:section:select", (e) =>
    bindButtons(e.target)
  );

  // Observe ajax DOM changes
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1) bindButtons(n);
        });
      }
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true });
})();
